import { type ClassValue, clsx } from "clsx";

// Tiny re-export so callers don't need to know which underlying lib is in use.
// If Tailwind class conflicts become a problem, swap in tailwind-merge here.
export const cx = (...inputs: ClassValue[]): string => clsx(inputs);
